import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { iRootState, Dispatch } from '../redux/store';

const ErrorModal = function ErrorModal(): React.ReactElement {
  const dispatch = useDispatch<Dispatch>();
  const error = useSelector((state: iRootState) => state.error);
  const open = Boolean(error.title && error.message);

  const onClose = function handleOnClose(): void {
    dispatch.error.clearError();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '400px',
            minHeight: '150px'
          }
        }}
      >
        <DialogTitle>{error.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{error.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color='primary' onClick={onClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ErrorModal;
